export default "__VITE_ASSET__BxOu9GTP__"